import * as React from 'react';
const PuntiNeriIcon = ({ primaryColor, secondaryColor, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-1,.prefix__cls-2{stroke:${secondaryColor ||
        '#ffcf38'};fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px}.prefix__cls-2{stroke:${primaryColor ||
        '#282828'}}`}</style>
    </defs>
    <path
      d="M119.93 120.75c4.84-1.59 6-6.19 12.77-6.19 7.18 0 8.05 5.2 13.72 6.44M53.57 121.01c5.65-1.25 6.53-6.44 13.72-6.44 6.77 0 7.94 4.59 12.77 6.19M53.57 98.78h35.4c.89 0 1.59.75 1.55 1.64-.11 2.1-.56 6-2.17 10.2-.76 1.97-1.18 4.02-1.18 5.94 0 7.08 5.74 12.82 12.82 12.82s12.82-5.74 12.82-12.82c0-1.92-.42-3.98-1.18-5.94-1.72-4.48-2.07-8.18-2.15-10.23-.03-.88.66-1.61 1.55-1.61h35.39"
      className="prefix__cls-2"
    />
    <path
      d="M106.35 116.18c0 3.51-2.84 6.35-6.35 6.35s-6.35-2.84-6.35-6.35c0-2.35 2.86-7.97 4.74-11.4.7-1.27 2.52-1.27 3.21 0 1.88 3.43 4.74 9.04 4.74 11.4ZM89.8 81.98l-3.27-8.99M100 81.25V70.62M110.22 81.93l3.25-8.94"
      className="prefix__cls-1"
    />
  </svg>
);
export default PuntiNeriIcon;
